import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IFeatureState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getFeatureState = (state: IAppState) => state[Reducer.statePropName];

export const isFeatureReady = (state: IAppState) => getFeatureState(state).ready;

export const getSubscriptionStatuses = (state: IAppState) => getFeatureState(state).statuses;

export const hasCancelledWebSubscriptions = (state: IAppState) => {
  const statuses = getSubscriptionStatuses(state);
  if (!statuses) {
    return false;
  }
  return statuses.some((status) => {
    return status.channel === 'web' && status.status === 'non_renewing';
  });
};

export const getSubscriptions = (state: IAppState) => getFeatureState(state).subscriptions;

export const getSubscriptionCreationDate = (state: IAppState) => {
  const subscriptions = getSubscriptions(state);
  if (!subscriptions || !subscriptions.length) {
    return;
  }
  return subscriptions[0].createdAt;
};
